<script setup lang="ts">
const { name, animation = undefined } = defineProps<{
  name: string;
  animation?: "spin";
}>();

const classObject = computed(() => ({
  [`has-animation-${animation}`]: animation,
}));
</script>

<template>
  <span class="base-icon material-icons-sharp" :class="classObject">
    {{ name }}
  </span>
</template>

<style lang="scss" scoped>
.base-icon {
  &.has-animation-spin {
    animation: spin 1500ms linear infinite;
  }
}
</style>

<style lang="scss">
.material-icons-sharp {
  display: inline-block;
  font-weight: normal;
  font-size: 24px;
  font-family: "Material Icons", serif;
  font-style: normal;
  -webkit-font-feature-settings: "liga";
  line-height: 1;
  letter-spacing: normal;
  white-space: nowrap;
  direction: ltr;
  text-transform: none;
  overflow-wrap: normal;
  -webkit-font-smoothing: antialiased;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
